import { render, staticRenderFns } from "./SnapshotModal.vue?vue&type=template&id=06e54a0a&"
import script from "./SnapshotModal.vue?vue&type=script&lang=js&"
export * from "./SnapshotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e54a0a')) {
      api.createRecord('06e54a0a', component.options)
    } else {
      api.reload('06e54a0a', component.options)
    }
    module.hot.accept("./SnapshotModal.vue?vue&type=template&id=06e54a0a&", function () {
      api.rerender('06e54a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/SnapshotModal.vue"
export default component.exports